import { render, staticRenderFns } from "./user_management.vue?vue&type=template&id=5363083c&scoped=true"
import script from "./user_management.vue?vue&type=script&lang=js"
export * from "./user_management.vue?vue&type=script&lang=js"
import style0 from "./user_management.vue?vue&type=style&index=0&id=5363083c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5363083c",
  null
  
)

export default component.exports